import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'scratch-blocks',
  size: 24,
  node: [
    [
      'path',
      {
        d: 'M19 5a2 2 0 012 2v11a2 2 0 01-2 2h-5.586a1 1 0 00-.707.293l-1.414 1.414a1 1 0 01-.707.293H8.414a1 1 0 01-.707-.293l-1.414-1.414A1 1 0 005.586 20H5a2 2 0 01-2-2V5.286c0-.394.11-.785.36-1.09a6 6 0 019.168-.133C12.996 4.6 13.637 5 14.35 5z',
        key: 'fo9iu6',
      },
    ],
    [
      'path',
      {
        d: 'M21 12h-7.586a1 1 0 00-.707.293l-1.414 1.414a1 1 0 01-.707.293H8.414a1 1 0 01-.707-.293l-1.414-1.414A1 1 0 005.586 12H3',
        key: '4ikqyq',
      },
    ],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name ScratchBlocks
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTkgNWEyIDIgMCAwMTIgMnYxMWEyIDIgMCAwMS0yIDJoLTUuNTg2YTEgMSAwIDAwLS43MDcuMjkzbC0xLjQxNCAxLjQxNGExIDEgMCAwMS0uNzA3LjI5M0g4LjQxNGExIDEgMCAwMS0uNzA3LS4yOTNsLTEuNDE0LTEuNDE0QTEgMSAwIDAwNS41ODYgMjBINWEyIDIgMCAwMS0yLTJWNS4yODZjMC0uMzk0LjExLS43ODUuMzYtMS4wOWE2IDYgMCAwMTkuMTY4LS4xMzNDMTIuOTk2IDQuNiAxMy42MzcgNSAxNC4zNSA1eiIgLz4KICA8cGF0aCBkPSJNMjEgMTJoLTcuNTg2YTEgMSAwIDAwLS43MDcuMjkzbC0xLjQxNCAxLjQxNGExIDEgMCAwMS0uNzA3LjI5M0g4LjQxNGExIDEgMCAwMS0uNzA3LS4yOTNsLTEuNDE0LTEuNDE0QTEgMSAwIDAwNS41ODYgMTJIMyIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/scratch-blocks
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ScratchBlocks = createLucideIcon(__iconData);

export default ScratchBlocks;
